<template>
  <div class="accruals-entity-tabs" data-testid="accruals-data-page__entity-tabs">
    <div class="accruals-entity-tabs__pills">
      <button
        v-for="tab in tabs"
        :key="tab.id"
        type="button"
        class="accruals-entity-tabs__pill"
        :class="{ 'accruals-entity-tabs__pill--active': tab.id === value }"
        :data-testid="`accruals-data-page__entity-tab--${tab.id}`"
        @click="$emit('input', tab.id)"
      >
        {{ tab.label }}
      </button>
    </div>

    <v-btn
      v-if="hasActiveTableFilter"
      text
      class="accruals-entity-tabs__clear-filter data-table-action__clear-filter-btn"
      data-testid="accruals-data-page__clear-filter-btn"
      @click="$emit('clear-filter')"
    >
      Clear Filter
    </v-btn>
  </div>
</template>

<script>
import { ACCRUALS_DATA_TABS } from '../accrualsDataConstants';

export default {
  name: 'AccrualsEntityTabs',
  props: {
    value: { type: String, default: 'open_po' },
    tabs: { type: Array, default: () => ACCRUALS_DATA_TABS },
    hasActiveTableFilter: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss" scoped>
@import './AccrualsEntityTabs.scss';
</style>
